import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { decrypt } from "../../../Util/util";

export default ({ clientId, amount, setValueAmount, setErrorMessage,errorMessage }) => {
    return (
        <div className="parent_btn_paypal">
            <PayPalScriptProvider options={{ "client-id": clientId }}>
                <PayPalButtons style={{ layout: "vertical" }}
                    createOrder={(data, actions) => {
                        return actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        value: amount,
                                    },
                                    custom_id: JSON.stringify({ user_id: JSON.parse(decrypt('user', localStorage.getItem('user'))).id }),
                                },
                            ],
                        });
                    }}
                    onApprove={(data, actions) => {
                        return actions.order.capture().then((details) => {
                            const name = details.payer.name.given_name;
                            console.log(`Transaction completed by ${name}`);
                            setErrorMessage({
                                show: true,
                                text: 'Successfully added balance',
                                type: 'success'
                            })

                            setTimeout(() => {

                                setErrorMessage({
                                    ...errorMessage,
                                    show: false,
                                })

                                setValueAmount('')
                            }, 3000);
                        });
                    }}
                />
            </PayPalScriptProvider>
        </div>
    )
}